<template>
    <div class="l-navigation-container" :class="{ 'l-navigation-container-disabled': disabled }">
        <button class="l-navigation-btn l-navigation-pre swiper-button-prev"></button>
        <div v-if="menuIndex !== 'MEDAL'" class="l-navigation-name">{{ title }}</div>
        <div v-else class="l-navigation-medal-name">
            <div>{{ name }}</div>
            <div>{{ dateName }}</div>
        </div>
        <button class="l-navigation-btn l-navigation-next swiper-button-next"></button>
    </div>
</template>

<script>
export default {
    name: "l-navigation-container",
    props: {
        name: {
            type: String,
        },
        disabled: {
            type: Boolean,
        },
        menuIndex: {
            type: String,
        },
        dateName: {
            type: String,
        }
    },
    data() {
        return {
            title: "",
        }
    },
    watch: {
        name(val) {
            this.title = val
        },
    },
    created() {
        this.title = this.name
    },
    methods: {},
}
</script>

<style lang="stylus">
@import './index.styl';
</style>
